import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PreviewPopupComponent } from 'src/app/modules/digital-memory-log/components/file-detail/components/preview-popup/preview-popup.component';

@Injectable({ providedIn: 'root' })
export class PreviewHelperService {
  constructor(private modalService: NgbModal, private toastr: ToastrService) {}


  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getFileSize(file: any): string {
    if (!file.size || Number(file.size) <= 0) {
      return 'Unknown size';
    }
    return this.formatFileSize(file.size);
  }

  openPreview(file: any, type: 'file' | 'photo' | 'video', allowDownload: boolean = true): void {
    try {
      if (type === 'file') {
        if (file.url) {
          window.open(file.url, '_blank');
        } else {
          this.toastr.error('File cannot be opened in browser', 'Error');
        }
      } else if (type === 'photo' || type === 'video') {
        const modalRef = this.modalService.open(PreviewPopupComponent, {
          size: 'lg',
          backdrop: 'static',
          keyboard: false,
          centered: true,
          windowClass: 'preview-modal',
        });
        modalRef.componentInstance.file = { ...file, fileSize: this.getFileSize(file) };
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.allowDownload = allowDownload;
      } else {
        this.toastr.info('Preview not available for this file type', 'Info');
      }
    } catch (error) {
      this.toastr.error('Error opening preview. Please try again.', 'Error');
    }
  }
}